import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import loginImg from "../assets/Login/login.png";
// import logo from "../assets/Login/aliklogo.png";
import { FaGoogle, FaFacebookF, FaLock, FaUser } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

function Login() {
    const { login } = useAuth();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const passwordInputRef = useRef(null);
    const navigate = useNavigate();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    // const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    useEffect(() => {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener("popstate", handlePopstate);
        return () => {
            window.removeEventListener("popstate", handlePopstate);
        };
    }, []);

    const handlePopstate = () => {
        window.history.pushState(null, null, window.location.pathname);
    };

    const handleLogin = async () => {
        if (!username || !password) {
            alert("Please enter both username and password.");
            return;
        }
        const apiUrl = `${apiBaseUrl}/user/SignIn/JAPAN_ACCESORIES?username=${username}&password=${password}`;

        try {
            const response = await fetch(apiUrl);

            if (response.ok) {
                const data = await response.json();
                if (data.length > 0) {
                    const user = data[0];

                    // Check if the user active is 0
                    if (user.Active === 0) {
                        // Redirect to the OTP page or handle it as required
                        navigate("/Otp", {
                            state: { username, password },
                        });

                        return;
                    }
                    login({
                        Ledcode: user.Ledcode,
                        LedName: user.LedName,
                        CustomerType: user.CustomerType,
                        AgentCode: user.AgentCode,
                    });

                    navigate("/Home");

                    // navigate("/Home", {
                    //     state: {
                    //         isGuest: false,
                    //         Ledcode: user.Ledcode,
                    //         customer: user.CustomerType,
                    //         AgentCode: user.AgentCode,
                    //     },
                    // });

                    // sessionStorage.setItem("Ledcode", user.Ledcode);
                    // sessionStorage.setItem("LedName", user.LedName);
                    // sessionStorage.setItem("CustomerType", user.CustomerType);
                    // sessionStorage.setItem("AgentCode", user.AgentCode);
                } else {
                    alert("Login failed. Please check your username and password.");
                }
            } else {
                alert("Login failed. Please check your username and password.");
            }
        } catch (error) {
            console.error("Error during login:", error);
            alert("An error occurred. Please try again.");
        }
    };

    const handleUsernameKeyPress = (event) => {
        if (event.key === "Enter") {
            passwordInputRef.current.focus();
        }
    };

    const handlePasswordKeyPress = (event) => {
        if (event.key === "Enter") {
            handleLogin();
        }
    };
    const home = async () => {
        navigate("/");
    };
    const signup = async () => {
        navigate("/signup");
    };
    const resetPassword = async () => {
        navigate("/");
    };

    return (
        <div className="min-h-screen  flex justify-center items-center bg-[#F7F7F7]">
            <div className="flex flex-row  bg-white w-[100%] h-[100vh]  bg-[white]">
                <div className="flex flex-col  w-[100%] py-2 lg:py-4  lg:w-[50%] h-[100%] bg-[white] ">
                    <div className="flex justify-center items-center w-full h-[90%] my-6">
                        <div className="flex flex-col w-[90%] md:w-[75%] h-[80%] gap-4 md:gap-6 ">
                            <div className="flex flex-col mx-10 ">
                                <h2 className="text-2xl font-bold text-black mb-2 md:mb-4">Login to your account</h2>
                                <div className="flex flex-col sm:flex-row mb-2 md:mb-4">
                                    <p className="text-gray-400 text-[#d1d5db]">Welcome back </p>
                                    <span className="hidden sm:block text-gray-400 text-[#d1d5db] mx-2">| </span>
                                    <p className="text-gray-400 text-[#d1d5db]"> Select method to go in</p>
                                </div>
                                {/* Social Login Buttons */}
                                <div className="flex gap-4 mt-2 md:mt-4">
                                    <button className="flex items-center justify-center w-1/2 border border-[#d1d5db] rounded-md py-2 hover:bg-gray-50 transition">
                                        <FaGoogle className="text-lg mr-2 text-[#DB4437]" />
                                        <span className="text-gray-600">Google</span>
                                    </button>
                                    <button className="flex items-center justify-center w-1/2 border border-[#d1d5db] rounded-md py-2 hover:bg-gray-50 transition">
                                        <FaFacebookF className="text-lg mr-2 text-[#1877F2]" />
                                        <span className="text-gray-600">Facebook</span>
                                    </button>
                                </div>

                                {/* Divider */}
                                <div className="flex items-center my-6">
                                    <hr className="flex-grow border-[#d1d5db]" />
                                    <span className="px-2 text-sm text-gray-400">Or continue with email</span>
                                    <hr className="flex-grow border-[#d1d5db]" />
                                </div>

                                {/* Email Field */}
                                <div className="relative mb-4 md:mb-6">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                        <FaUser className="text-[#8b0000]" />
                                    </span>
                                    <input
                                        type="email"
                                        placeholder="Username"
                                        className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        onKeyPress={handleUsernameKeyPress}
                                        required
                                    />
                                </div>

                                {/* Password Field */}
                                <div className="relative mb-6">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                        <FaLock className="text-[#8b0000]" />
                                    </span>
                                    <input
                                        type="password"
                                        placeholder="Password"
                                        className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onKeyPress={handlePasswordKeyPress}
                                        ref={passwordInputRef}
                                        required
                                    />
                                </div>

                                {/* Remember me and Forget password */}
                                <div className="flex flex-col sm:flex-row justify-between items-center mb-6 text-sm">
                                    <label className="flex items-center gap-2 text-gray-500">
                                        <input type="checkbox" className="form-checkbox cursor-pointer" />
                                        Remember me
                                    </label>
                                    <span className="text-[#2563EB] font-medium cursor-pointer" onClick={resetPassword}>
                                        Forgot password ?{" "}
                                    </span>
                                </div>

                                <div
                                    className="w-[100%] md:h-[14%] h-[10%]  py-3 rounded-[8px] bg-[#8B0000] font-display text-[15px] md:text-[20px] font-[500] text-[white] flex justify-center items-center cursor-pointer"
                                    onClick={handleLogin}
                                >
                                    Log In
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row justify-center items-center gap-2">
                                <span className="font-display text-sm md:text-[18px] font-[300] text-[gray]">
                                    Don't have an account?
                                </span>
                                <span
                                    className="font-display text-sm md:text-[18px] font-[600] text-[#2563EB] cursor-pointer "
                                    onClick={signup}
                                >
                                    Create an account
                                </span>
                            </div>
                            <div className="flex flex-col sm:flex-row justify-center items-center gap-2">
                                <span
                                    className="font-display text-sm md:text-[18px] font-[300] text-[#2563EB] cursor-pointer "
                                    onClick={home}
                                >
                                    Access without an account
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" w-[50%] h-[100%] hidden lg:block bg-[#8b0000] rounded-l-[51px]">
                    <img src={loginImg} alt="login" className="rounded-l-[51px] h-full mx-auto " />
                </div>
            </div>
        </div>
    );
}

export default Login;
